<template>
  <div class="gift-detail">
    <div>
      <img :src="info.skuImgs" >
    </div>
    <div class="gift-name">
      <div>
        {{info.skuName}}
      </div>
      <div class="gift-inventory">
        库存：{{info.inventoryNum}}
      </div>
    </div>
    <div class="line"></div>
    <div v-if="info.skuDetailImg">
      <div class="gift-detail-image-title"> 礼品详情</div>
      <div>
        <img :src="info.skuDetailImg" >
      </div>
    </div>
    <div class="bottom">
        <div class="bottom-btn" @click="goPage()" >兑换</div>
    </div>
  </div>
</template>

<script>

export default {
  name: "giftDetail",
  data() {
    return {
      info: this.$route.query,
    };
  },
  created() {
    console.log("info",this.$route.query)
    // this.onLoad()
  },
  methods: {
    
    goPage(){
      if(this.info.skuStatus == 2){
        return
      }
      this.$router.push({
        path:'/input',
        query:this.info
      })
    },
  }
};
</script>
<style lang="scss">
.gift-detail {
  padding-bottom: 83px;
  .gift-name{
    margin: 16px 12px 18px 12px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #323232;
    .gift-inventory {
      width: 100px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #868686;
      text-align: end;
      margin-top: 3px;
    }
  }
  .line{
    width: 100%;
    height: 8px;
    background: #F5F5F5;
    margin-bottom: 16px;
  }
  .gift-detail-image-title{
    margin-left: 12px;
    margin-bottom: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #323232;
  }
  .bottom{
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 83px;
    background: #FFFFFF;
    padding-top: 8px;
    .bottom-btn {
      margin: 0 12px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #41BA9E;
      border-radius: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 18px;
      color: #F7F0DC;
    }
  }
}
</style>
